import { PropsWithChildren } from "react";
import { useTranslations } from "next-intl";
import styled from "styled-components";

import { useState, useEffect } from "react";
import SafeHtml from "@src/components/SafeHtml";
import { Content } from "@src/packages/chime-ui/components/Content";
import { colors } from "@src/packages/chime-ui/system";

import { Layout, ListItemText, PageTitle, StickyButton } from "@src/packages/chime-ui";

import { Shield } from "@src/components";
import { NumberCircle } from "@src/packages/chime-ui/components/NumberCircle";
import { StrongText, StrongTextSpaced } from "@src/packages/chime-ui/components/Typography";

interface Props extends PropsWithChildren<{}> {
  onSubmit: () => void;
  showConsent?: boolean;
  privacyNotice?: string;
}

const InlineIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Explainer = ({ onSubmit, children, showConsent = false, privacyNotice = "" }: Props) => {
  const t = useTranslations("explainer");

  return (
    <Layout>
      <Shield />
      <PageTitle role="heading">{t("title")}</PageTitle>
      <StrongTextSpaced>{t("description")}</StrongTextSpaced>
      {children}
      <InlineIconWrapper>
        <NumberCircle>
          <StrongText>1</StrongText>
        </NumberCircle>
        <ListItemText>{t("step1")}</ListItemText>
      </InlineIconWrapper>
      <InlineIconWrapper>
        <NumberCircle>
          <StrongText>2</StrongText>
        </NumberCircle>
        <ListItemText>{t("step2")}</ListItemText>
      </InlineIconWrapper>
      <InlineIconWrapper>
        <NumberCircle>
          <StrongText>3</StrongText>
        </NumberCircle>
        <ListItemText>{t("step3")}</ListItemText>
      </InlineIconWrapper>
      <StickyButton onClick={onSubmit}>{t("cta")}</StickyButton>
      {showConsent && (
        <Content>
          <SafeHtml html={privacyNotice} />
        </Content>
      )}
    </Layout>
  );
};
